import { FC } from 'react';
import { TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';

interface SearchFormProps {
  searchValue: string;
  onChange: (value: string) => void;
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

export const SearchForm: FC<SearchFormProps> = ({ searchValue, onChange, handleSubmit }) => {
  const { t: tRecruitingAuditions } = useTranslationWithLang('recruitingAuditions');

  const handleClear = () => {
    onChange('');
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div style={{ position: 'relative' }}>
        <TextField
          label={
            <>
              <SearchIcon className="mr-2" />
              {tRecruitingAuditions('TU009_002')}
            </>
          }
          variant="outlined"
          id="keyword"
          fullWidth
          value={searchValue}
          onChange={handleChange}
        />
        {searchValue && (
          <ClearIcon
            style={{
              position: 'absolute',
              right: 10,
              top: '50%',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
            }}
            onClick={handleClear}
          />
        )}
      </div>
    </form>
  );
};
